import { Nav, NavDropdown, Navbar } from "react-bootstrap";
import DefaultUser from "./../../assets/images/default-user.png";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getMasterProfileRequest,
  getProfileRequest,
} from "./../../services/authService";
import {
  updateMasterProfile,
  updateUserProfile,
} from "../../store/actions/auth";

const Header = () => {
  const [arrowDown, setArrowDown] = useState(true);
  const { profile_image, first_name, last_name, company_master_account } =
    useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const init = useCallback(async () => {
    const profile = await getProfileRequest();
    const masterProfile = await getMasterProfileRequest();

    dispatch(updateUserProfile(profile));
    dispatch(updateMasterProfile(masterProfile));
  }, [dispatch]);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <div className="main-header d-flex w-100 bg-light align-items-center px-xl-5 px-3 py-3 justify-content-between border-bottom border-1">
      <p
        className="h2 fw-bolder mb-0 text-capitalize"
        style={{ color: "#28BF8D" }}
      >
        Welcome, {first_name}
      </p>

      <Navbar className="p-0">
        <Nav className="me-auto">
          <NavDropdown
            onToggle={() => setArrowDown(!arrowDown)}
            className="d-flex py-0 custom-dropdown-toggle"
            title={
              <div className="d-flex align-items-center">
                <img
                  src={profile_image || DefaultUser}
                  alt="Avatar"
                  width={40}
                  height={40}
                  className="rounded-circle me-2"
                />
                <div>
                  <div className="fw-semibold text-capitalize">
                    {first_name} {last_name}
                  </div>
                  <div className="text-dark text-sm">
                    {company_master_account?.company_name || ""}
                  </div>
                </div>
                {arrowDown ? (
                  <FaChevronDown className="ms-2" />
                ) : (
                  <FaChevronUp className="ms-2" />
                )}
              </div>
            }
          >
            <NavDropdown.Item href="/logout">Log Out</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar>
    </div>
  );
};

export default Header;
